import React,{useEffect, useState} from 'react';
import DataTable from 'react-data-table-component';
import {Link} from 'react-router-dom'

const BulkUploadedTable = (props) => {
   const [studentDetail,setStudentDetail] = useState([]);
   const [search,setSearch] = useState('');
   const [filteredStudent,setFilteredStudent] = useState([]);
const studentDataList = props.studentData !== undefined && props.studentData;

   useEffect(() => {
         setFilteredStudent(studentDataList !== undefined &&studentDataList)
      
   },[props.studentData]);


   const columns = [
      {
         name : 'Country',
         selector : row => row.country,
         sortable : true
      },
      {
         name : 'Name',
         selector : row => row.name,
         sortable : true
      },
      {
         name : 'Email',
         selector : row => row.email,
         sortable : true
      },
      {
         name : 'Phone',
         selector : row => row.phone
      },
      {
         name : 'City',
         selector : row => row.city,
         sortable : true
      },
      {
         name : 'School',
         selector : row => row.school || row.other_school,
         sortable : true
      },
      {
         name : 'Class',
         selector : row => row.class,
         sortable : true
      },
      {
         name : 'Stream',
         selector : row => row.stream,
         sortable : true
      },
      {
         name : 'Paid',
         selector : row => row.paid,
         sortable : true
      },
     
      
   ]


   const searchChange=(e)=>{
      setSearch(e.target.value)

      let val=e.target.value
      const result = studentDataList !== undefined && studentDataList.filter(student => {
           return student.name.toLowerCase().match(e.target.value.toLowerCase()) || student.email.match(e.target.value)
         // || student.form_num.toString().match(e.target.value)
       })
       setFilteredStudent(result)

   }
    return(
        <DataTable 
        title="Student List"
        fixedHeader 
        highlightOnHover 
        columns={columns} 
        data={filteredStudent} 
        responsive={true}
        subHeader
        subHeaderComponent={<><input type="text" placeholder='Search here' value={search} onChange={searchChange} className='w-25 form-control'/>
        </>}
        subHeaderAlign="right"

        pagination/>
    )
}

export default BulkUploadedTable;